import { AvailabilityFilters } from "@/modules/AvailabilityCalendar/models/AvailabilityFilter";
import { AvailabilityFiltersResponse } from "@/modules/AvailabilityCalendar/models/AvailabilityFiltersResponse";
import { useQuery } from "@tanstack/vue-query";
import useApi from "../../../composables/useApi";

const useAvailabilityFiltersQuery = () => {
    const { get } = useApi();

    const fetcher = () => {
        return get<AvailabilityFiltersResponse>("/availability/config", {}).then((resp) => new AvailabilityFilters(resp.data));
    };

    return {
        ...useQuery({
            queryKey: ["filters"],
            queryFn: fetcher,
            refetchOnWindowFocus: false,
            staleTime: Infinity,
            retry: false,
        }),
    };
};

export default useAvailabilityFiltersQuery;
